import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Commons from "./pages/Commons";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import Inbox from "./pages/Inbox";
import ConciergeChat from "./components/ConciergeChat";
import { Toaster } from "./components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/commons" element={<Commons />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/legal/:slug" element={<Legal />} />
            <Route path="/inbox" element={<Inbox />} />
          </Routes>
        </main>
        <Footer />
        <ConciergeChat />
        <Toaster position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
